export class TwoFactorAuthStatusModel {
    constructor() {
        this.isTwoFactorAuthEnabled = false;
        this.twoFactorAuthEnabledOn = null;
        this.twoFactorAuthEnabledOnAsString = "";
    }
}
export default class TwoFactorAuthStatus extends TwoFactorAuthStatusModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
